import { User } from 'models/user';
import { UserFromFaweb } from 'models/userFromFaweb';

export const mergeUsersArray = function (fsdbUsers: User[], fawebUsers: UserFromFaweb[]): User[] {
    // Merges User[] and UserFromFaweb[] schemas by ID
    // @note  If a username or name is missing from an fawebUser, the resulting user
    //        will contain the orginal values from the fsdbUser (which is likely to be blank)
    return fsdbUsers.map((fsdbUser) => ({
        ...fsdbUser,
        ...fawebUsers.find((fawebUser) => fawebUser.id === fsdbUser.id),
    }));
};
